<script>
  import { onMount } from "svelte";
  import { API_DIR, showLoadingModal } from "../store";
  import Th from "../Tables/Th.svelte";
  import { DataHandler } from "@vincjo/datatables";
  import { each } from "svelte/internal";
  import { toasts } from "svelte-toasts";
  //import from chartjs
  import Chart from "chart.js/auto";

  let isMounted = false;
  let jobsGroupsResponse = [];
  let groupUpdatesCount = 0;
  let groupCreatedCount = 0;
  let groupProcessingCount = 0;
  let groupFailedCount = 0;
  let groupCanceledCount = 0;
  let groupCompletedCount = 0;
  let groupSelected = "Select campaign...";
  let groupCreationDate = "0000-00-00";
  let gorupCreatedBy = "Unknown";
  let groupChart;
  let chartData;
  let optionsDisabled = true;
  let useDefaultGroup = true;

  $: groupSelected, processGroupSelected();

  $: jobsGroupsResponse, changeOptionsAvailability();

  async function changeOptionsAvailability() {
    if (jobsGroupsResponse.length > 0) {
      optionsDisabled = false;
      //select most recent group by date

      if (useDefaultGroup) {
        const mostRecentGroup = jobsGroupsResponse.reduce((prev, current) =>
          prev.creation_date > current.creation_date ? prev : current
        );

        groupSelected = mostRecentGroup.tag_group;
        console.log("MOST RECENT GROUP", mostRecentGroup);

        //format date
        groupCreationDate = mostRecentGroup.date_created;
        groupCreationDate = new Date(groupCreationDate).toLocaleDateString();
        gorupCreatedBy = mostRecentGroup.created_by;

        useDefaultGroup = false;
      } else {
        const group = jobsGroupsResponse.find(
          (group) => group.tag_group === groupSelected
        );
        groupCreationDate = group.date_created;
        groupCreationDate = new Date(groupCreationDate).toLocaleDateString();
        gorupCreatedBy = group.created_by;
      }

      await processGroupSelected();

    } else {
      optionsDisabled = true;
    }
  }

  async function updateGroupSelectedStatus(new_status) {
    let retryMessageConfirmation =
      "Are you sure you want to retry all failed updates?";
    let cancelMessageConfirmation =
      "Are you sure you want to cancel all updates?";
    const confirmation = confirm(
      new_status === "failed"
        ? retryMessageConfirmation
        : cancelMessageConfirmation
    );

    if (confirmation) {
      const response = await fetch(
        `${$API_DIR}/api/v1/update-all-status-by-group`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Session-Id": localStorage.getItem("session_id")
          },
          body: JSON.stringify({
            tag_group: groupSelected,
            new_status
          })
        }
      );

      if (response.status === 401) {
        location.reload();
      }

      if (!response.ok) {
        console.error("Could not update group status");
        return;
      }

      const responseJson = await response.json();
      console.log("RESPONSE", responseJson);
      await setUp();
    }
  }

  async function updateJobById(jobId, newStatus) {
    const confirmation = confirm(
      "Are you sure you want to cancel this update queue?"
    );

    if (!confirmation) {
      return;
    }

    try {
      showLoadingModal.set(true);

      const response = await fetch(`${$API_DIR}/api/v1/set-update-status`, {
        method: "POST",
        body: JSON.stringify({ update_id: jobId, new_status: newStatus }),
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem("session_id")
        }
      });

      showLoadingModal.set(false);

      if (response.status === 401) {
        location.reload();
      }

      if (!response.ok) {
        toasts.error("Could not cancel update");
      }

      if (response.ok) {
        toasts.success("Update canceled");
        await setUp();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getJobsGroups() {
    const response = await fetch(`${$API_DIR}/api/v1/get-jobs-groups`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Session-Id": localStorage.getItem("session_id")
      }
    });

    if (response.status === 401) {
      location.reload();
    }

    if (!response.ok) {
      console.error("Could not get jobs groups");
      return;
    }

    const responseJson = await response.json();
    return responseJson;
  }

  async function processGroupSelected() {
    console.log("GROUP SELECTED", groupSelected);

    //reset counters
    groupUpdatesCount = 0;
    groupCreatedCount = 0;
    groupProcessingCount = 0;
    groupFailedCount = 0;
    groupCanceledCount = 0;
    groupCompletedCount = 0;

    if (groupSelected != "Select campaign...") {
      const group = jobsGroupsResponse.find(
        (group) => group.tag_group === groupSelected
      );

      console.log("GROUP loaded", group);

      for (const job of group.jobs) {
        groupUpdatesCount++;

        if (job.status === "created") {
          groupCreatedCount++;
        } else if (job.status === "processing") {
          groupProcessingCount++;
        } else if (job.status === "failed") {
          groupFailedCount++;
        } else if (job.status === "completed") {
          groupCompletedCount++;
        }else if (job.status === "canceled") {
          groupCanceledCount++;
        }

      }
      chartData = {
        labels: ["Created", "Processing", "Failed", "Canceled", "Completed"],
        datasets: [
          {
            label: "Updates",
            data: [groupCreatedCount, groupProcessingCount, groupFailedCount, groupCanceledCount, groupCompletedCount],
            backgroundColor: ["rgb( 208, 208, 208 )", "rgb( 208, 208, 208 )", "rgb(220, 53, 69)", "rgb(220, 53, 69)", "rgb(25, 135, 84)"],
            hoverOffset: 4
          }
        ]
      };

      updateChart();
    }
  }

  function updateChart() {
    console.log("UPDATING CHART");
    if (groupChart) {
      groupChart.destroy();
    }

    let chartElement = document.getElementById("groupChart") || null;

    if (chartElement) {
      const ctx = document.getElementById("groupChart").getContext("2d");
      groupChart = new Chart(ctx, {
        type: "doughnut",
        data: chartData,
        options: {
          cutout: "80%",
          plugins: {
            legend: {
              position: "top",
              display: false
            },
            title: {
              display: false,
              text: "Updates"
            }
          }
        }
      });
    }
  }

  async function setUp() {
    jobsGroupsResponse = await getJobsGroups();
    console.log("GROPUS", jobsGroupsResponse);
    //await changeOptionsAvailability();
    //await processGroupSelected();
  }

  onMount(async () => {
    isMounted = true;
    await setUp();
    updateChart();
  });
</script>

{#if isMounted}
  <hr />
  <div class="row">
    <div class="col-lg-3 d-flex justify-content-start">
      <div>
        <h2>Campaigns</h2>
      </div>
    </div>

    <div class="col-9 d-flex justify-content-end">
      <div class="input-group" style="max-width: 450px; margin-right:8px">
        <span class="input-group-text" id="basic-addon1">Campaign Name: </span>
        <select
          class="form-select form-select"
          aria-label="Default select example"
          disabled={optionsDisabled}
          bind:value={groupSelected}
        >
          {#each jobsGroupsResponse as group}
            <option value={group.tag_group}>{group.tag_group}</option>
          {/each}
        </select>
      </div>

      <div class="d-flex justify-content-end">
        <button
          class="btn btn-danger"
          style="margin-right:8px;"
          disabled={optionsDisabled}
          on:click={async () => {
            await updateGroupSelectedStatus("canceled");
          }}
        >
          Cancel All <i class="bi bi-x-circle"></i>
        </button>

        <button
          class="btn btn-success"
          disabled={optionsDisabled}
          on:click={async () => {
            await updateGroupSelectedStatus("created");
          }}
        >
          Retry Failed <i class="bi bi-arrow-repeat"></i>
        </button>
      </div>
    </div>
  </div>

  <hr />

  {#if optionsDisabled}
    <div class="d-flex justify-content-center" style="min-height:300px">
      <div class="d-flex align-self-center">
        <h3>No campaigns available.</h3>
      </div>
    </div>
  {:else if groupSelected != "Select campaign..." && !optionsDisabled}
    <div class="d-flex justify-content-around">
      <div class=" btn-outline-secondary" style="pointer-events: none;">
        Updates <span class="badge bg-secondary">{groupUpdatesCount}</span>
      </div>

      <div class=" btn-outline-secondary" style="pointer-events: none;">
        Created <span class="badge bg-primary">{groupCreatedCount}</span>
      </div>

      <div class=" btn-outline-secondary" style="pointer-events: none;">
        Processing <span class="badge bg-warning">{groupProcessingCount}</span>
      </div>

      <div class=" btn-outline-secondary" style="pointer-events: none;">
        Failed <span class="badge bg-danger">{groupFailedCount}</span>
      </div>

      <div class=" btn-outline-secondary" style="pointer-events: none;">
        Canceled <span class="badge bg-danger">{groupCanceledCount}</span>
      </div>


      <div class=" btn-outline-secondary" style="pointer-events: none;">
        Completed <span class="badge bg-success">{groupCompletedCount}</span>
      </div>
    </div>

    <hr />

    <br />

    <div class=" row">
      <div class="col-6">
        <div
          class="d-flex align-self-center justify-content-center"
          style="height:100%"
        >
          <div class="d-flex align-self-center">
            <div>
              <div
                class=" d-flex justify-content-center align-items-center position-relative"
              >
                <canvas
                  id="groupChart"
                  class="align-self-center"
                  style="max-height:400px; max-width:400px; z-index: 1;"
                ></canvas>
                <div
                  id="groupChartRate"
                  class="align-self-center position-absolute top-50 start-50 translate-middle"
                  style="z-index: 2;"
                >
                  <h3
                    id="completedRateLabek"
                    class=" d-flex justify-content-center"
                  >
                    {(( (groupCanceledCount + groupCompletedCount + groupFailedCount) / groupUpdatesCount) * 100).toFixed(
                      0
                    )}%
                  </h3>
                  <div class=" d-flex justify-content-center">FINISHED</div>
                </div>
              </div>

              <br />

              <div>
                <div class="d-flex justify-content-center">
                  <h5>Created by: {gorupCreatedBy}</h5>
                </div>

                <div class="d-flex justify-content-center">
                  <h5>Creation date: {groupCreationDate}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 table-responsive" style="max-height:70vh;">
        <table class=" table table-hover">
          <thead>
            <tr>
              <th scope="col">Device ID</th>
              <th scope="col">Filename</th>
              <th scope="col">Type</th>
              <th scope="col">Status</th>
              <th scope="col">Option</th>
            </tr>
          </thead>
          <tbody>
            {#if groupSelected != "Select campaign..."}<!--TODO: CASE IF LIST IS EMPTY-->
              {#each jobsGroupsResponse.find((group) => group.tag_group === groupSelected).jobs as job}
                <tr>
                  <td>{job.job_id.slice(1, 11)}</td>
                  <td>{job.filename}</td>
                  <td>{job.type}</td>

                  {#if job.status == "created"}
                    <td>
                      <i class="bi bi-circle-fill text-primary"></i>
                    </td>
                  {:else if job.status == "processing"}
                    <td>
                      <i class="bi bi-circle-fill text-warning"></i>
                    </td>
                  {:else if job.status == "failed"}
                    <td>
                      <i class="bi bi-circle-fill text-danger"></i>
                    </td>
                  {:else if job.status == "canceled"}
                    <td>
                      <i class="bi bi-circle-fill text-danger"></i>
                    </td>

                    {:else if job.status == "completed"}
                    <td>
                      <i class="bi bi-circle-fill text-success"></i>
                    </td> 
                  {:else}
                    <td>
                      <i class="bi bi-circle-fill text-secondary"></i>
                    </td>
                  {/if}

                  <td>
                    {#if job.status != "processing" && job.status != "completed"}
                      <button
                        class="btn btn-sm custom-dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        on:click={() => {
                          console.log("Details");
                        }}
                      >
                        <i class="bi bi-three-dots-vertical text-secondary"></i>
                      </button>

                      <ul class="dropdown-menu">
                        {#if job.status == "created"}
                          <li>
                            <a
                              class="dropdown-item"
                              href={null}
                              on:click={async () => {
                                await updateJobById(job.job_id, "canceled");
                              }}>Cancel</a
                            >
                          </li>
                        {:else if job.status == "failed"}
                          <li>
                            <a
                              class="dropdown-item"
                              href={null}
                              on:click={async () => {
                                await updateJobById(job.job_id, "created");
                              }}>Retry</a
                            >
                          </li>
                        {/if}
                      </ul>
                    {/if}
                  </td></tr
                >
              {/each}
            {/if}
          </tbody>
        </table>

        <br />
      </div>
    </div>
    <br />
  {/if}
{/if}

<style>
  .custom-dropdown-toggle::after {
    content: none; /* Elimina el icono de flecha */
  }
</style>
